export default __webpack_public_path__ + "static/hacker4-2da6a7ae9aa2fbac19edbfa9bbbdf92e.jpeg";